module.exports = __webpack_public_path__ + "static/assets/9b4aae47faded4a9bdce5813342da304.jpg";